import React from "react";
import { Link } from "react-router-dom";
import './successfullReview.css';

const SuccessfullReviewHW = () => {
  return (
    <div className=" successful_preview_transprant_body1 ">
      <div className=" p-2 successful_preview_container shadow">
      <img src="/gift/tick_mark.gif" className="activityLoader" />
        <span className=" my-4 successfully_message">
        You have successfully submitted this Homework.
        </span>
        <Link to="/PublishedHomework">
          <button className="successfull_okay_btn">Okay</button>
        </Link>
      </div>
    </div>
  );
};

export default SuccessfullReviewHW;

